import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Packages from './pages/Packages'
import PackageDetail from './pages/PackageDetail'
import Blog from './pages/Blog'
import BlogDetail from './pages/BlogDetail'
import Contact from './pages/Contact'
import Europamundo from './pages/Europamundo'
import SeoDefaults from './components/SeoDefaults'
import ChatWidget from './components/ChatWidget'
import AdminRedirect from './pages/AdminRedirect'

function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <SeoDefaults />
      <ChatWidget />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/admin/*" element={<AdminRedirect />} />
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/:slug" element={<PackageDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/europamundo" element={<Europamundo />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App
